import { useContext } from "react";
import Separator from "components/shared/Separator";
import { Context } from "Context";

const mainClass = "syndicated-footer__disney-reservation-center";
const DisneyReservationCenter = ({ title, subtitle, footer }) => {
	const {
		config: { brand, locale },
	} = useContext(Context);

	return title || subtitle || footer ? (
		<div className={mainClass} data-nosnippet>
			<Separator section="footer" hideInMobile />
			<div className={`${mainClass}__container`}>
				{title && (
					<div
						className={`${mainClass}__container__title ${mainClass}__container__title--${brand}--${locale}`}
						dangerouslySetInnerHTML={{ __html: title }}
					/>
				)}
				{subtitle && (
					<div
						className={`${mainClass}__container__subtitle ${mainClass}__container__subtitle--${brand}--${locale}`}
						dangerouslySetInnerHTML={{ __html: subtitle }}
					/>
				)}
				{footer && (
					<div
						className={`${mainClass}__container__footer ${mainClass}__container__footer--${brand}--${locale}`}
						dangerouslySetInnerHTML={{ __html: footer }}
					/>
				)}
			</div>
			<Separator section="footer" hideInMobile />
		</div>
	) : null;
};

export default DisneyReservationCenter;
